/**
 * Human label for RogerDoc section keys; value stays the raw key.
 *
 * When `labelByCategory` is supplied (e.g. derived from a FormSchemaVersion's
 * `section_order`), an explicit display name there wins over the
 * underscore-stripping fallback. Callers that don't have a section_order map
 * (e.g. import/export tools aggregating across many FSVs) can omit the arg
 * and get the legacy regex behavior byte-for-byte.
 */
export function formatSectionDropdownLabel(
  sectionKey: string,
  labelByCategory?: Record<string, string>
): string {
  if (!sectionKey) return '';
  const override = labelByCategory?.[sectionKey];
  if (override) return override;
  // ASCII underscore (U+005F) and fullwidth low line (U+FF3F); collapse runs to one space
  return sectionKey
    .replace(/[\u005F\uFF3F]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
